import React, { useEffect, useState } from "react";
const bg2 = "/images/bg_2.png";
const gift1 = "/images/gift_1.png";
const gift2 = "/images/gift_2.png";
const calendar = "/images/calendar.png";

const Booked = () => {
  const [bookingData, setBookingData] = useState({
    day: "17",
    month: "января",
    time: "10:00",
  });

  useEffect(() => {
    // Получаем данные из sessionStorage
    const day = sessionStorage.getItem("bookingDay") || "17";
    const month = sessionStorage.getItem("bookingMonth") || "января";
    const time = sessionStorage.getItem("bookingTime") || "10:00";

    setBookingData({ day, month, time });
  }, []);

  return (
    <div className="wrapper booking-wrapper">
      <div className="bg booking-bg">
        <img src={bg2} alt="bg" />
      </div>

      <div className="gift gift-1">
        <img src={gift1} alt="gift 1" />
      </div>
      <div className="gift gift-2">
        <img src={gift2} alt="gift 2" />
      </div>

      <div className="booking-container">
        <div className="calendar-wrapper">
          <img src={calendar} alt="calendar" className="calendar-bg" />
          <div className="calendar-content booked-content">
            <div className="booked-block">
              <div className="day">{bookingData.day}</div>
              <div className="month">{bookingData.month}</div>
              <div className="separator"></div>
              <div className="time">{bookingData.time}</div>
            </div>

            <h2 className="booked-title">
              Ваши дата и время успешно забронированы
            </h2>

            <span className="booked-text">Вам придет смс уведомление</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booked;
